module.exports = __webpack_public_path__ + "img/bg-gym-grayscale.21030241.jpeg";